var render, staticRenderFns
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afc37d2a')) {
      api.createRecord('afc37d2a', component.options)
    } else {
      api.reload('afc37d2a', component.options)
    }
    
  }
}
component.options.__file = "resources/views/common/object/component/form/baseLp/stepGroup/component.vue"
export default component.exports